<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import { computed, onMounted, ref, watch } from 'vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import ThumbCell from '@/onenetwork/components/datatable/ThumbCell.vue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import AccountAPI from '@/modules/account/constants/account.api.uri.const'
import BrokerAPI from '../constants/broker.api.uri.const'
import { formatTableDataSubMember } from '../helper/table'

interface Props {
  account: object | null,
  currentTab?: string,
}

const props = defineProps<Props>()

const loading = ref<boolean>(false)
const pageSize = ref(10)
const page = ref(1)
const dataSource = ref({
  list: [],
  totalPage: 0,
  totalRecords: 0,
})

const handleChangePage = (page: number) => {
  if (page !== page.value) {
    page.value = page
    requestFetchData()
  }
}

const handleChangePageSize = (size: number) => {
  if (size !== pageSize.value) {
    pageSize.value = size
    page.value = 1 // Reset to first page when changing page size
    requestFetchData()
  }
}

const requestFetchData = async () => {

  try {
    const res = await APIClient.get(BrokerAPI.broker.sub_member, {
      params: {
        higher_broker_id: props.account?.user_id,
        page: page.value,
        page_size: pageSize.value,
      }
    })
    const {data} = res.data;
    if (res.data.code === 200) {
      dataSource.value = {
        list: formatTableDataSubMember(data.data) || [],
        totalPage: res.data.last_page,
        totalRecords: res.data.total,
      }
    }
  } catch (e: any) {

  }
}

watch(() => props.account, () => {
  requestFetchData()
}, { immediate: true })

// Watch for tab changes and refetch when on submember tab
watch(() => props.currentTab, (newTab) => {
  if (newTab === '2') {
    requestFetchData()
  }
})

onMounted(() => {
  requestFetchData()
})
</script>

<template>
  <data-table
    :loading="loading"
    :tableConfig="{
      canShowHide: false,
      columns: {
        code: { label: 'CODE', component: TextCell, visible: true, class: '', sort: false, config: {} },
        profile_pic: { label: 'Avatar', component: ThumbCell, visible: true, class: '', sort: false, config: {width: '40px', height: '40px', borderRadius: '4px'} },
        fullname: { label: 'Tên đầy đủ', component: TextCell, visible: true, class: '', sort: false, config: {} },
        phone: { label: 'Số điện thoại', component: TextCell, visible: true, sort: false, class: '', config: {} },
        email: { label: 'Email', component: TextCell, visible: true, sort: false, config: {} },
        type: { label: 'Loại hình', component: TextCell, visible: true, sort: false, config: {} },
        rate: { label: 'Điểm', component: TextCell, visible: true, sort: false, config: {} },
        level: { label: 'Cấp độ', component: TextCell, visible: true, sort: false, config: {} },
        submem: { label: 'Thành viên hệ thống', component: TextCell, visible: true, sort: false, config: {} },
        regdate: { label: 'Thời gian giao dịch', component: DateTimeCell, visible: true, class: '', sort: false, config: {} },

      }
    }"
    :page-size="pageSize"
    :page="page"
    :total-page="dataSource?.totalPage || 0"
    :total-records="dataSource?.totalRecords || 0"
    :data="dataSource?.list || []"
    @page-changed="handleChangePage"
    @pagesize-changed="handleChangePageSize"

  />
</template>

<style scoped>

</style>
